export default __webpack_public_path__ + "static/approach-5-5e8019e71c28f5b5bb48761128cdec2a.svg";